module.exports = __webpack_public_path__ + "img/4.ecb8a2d9.png";